import styled from 'vue-styled-components';

import theme from '@/config/theme';

export const Wrapper = styled.header`
  align-items: center;
  background-color: ${theme.colors.primaryBlue};
  display: flex;
  height: 68px;
  margin-bottom: 52px;
  justify-content: space-between;

  & > div {
    align-items: center;
    display: flex;
    height: 100%;
  }

  & > div:last-of-type {
    justify-content: flex-end;

    &.has-link-input {
      justify-content: space-between;
    }

    > div {
      align-items: center;
      display: flex;
      height: 100%;
    }
  }

  & div.nav {
    position: relative;
    a {
      border-left: none;
    }
  }

  & > div .notification {
    align-items: center;
    border-radius: ${theme.border.radius.circle};
    color: ${theme.colors.white};
    cursor: pointer;
    display: flex;
    height: 40px;
    justify-content: center;
    position: relative;
    width: 40px;

    &:hover {
      background: #582b71;
    }

    &.active {
      color: ${theme.colors.secondaryLight};
    }

    > span {
      bottom: 0;
      position: absolute;
      right: -5px;
    }
  }
`;

export const Link = styled.a`
  align-items: center;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  color: ${theme.colors.white};
  cursor: pointer;
  display: flex;
  font-size: ${theme.font.sizes.p2};
  gap: 10px;
  height: 100%;
  justify-content: center;
  line-height: ${theme.font.lineHeights.p2};
  margin-left: 40px;
  padding: 0 ${theme.spacings.xsmall};
  width: auto;

  &:hover {
    opacity: .8;
  }

  &.active {
    color: ${theme.colors.secondaryLight};

    > .chevron {
      transform: rotate(270deg);
    }
  }

  > .chevron {
    transform: rotate(90deg);
  }
`;

export const LinkInput = styled(Link)`
  border: none;
  margin-left: ${theme.spacings.medium};
  width: auto;

  &:hover {
    background: transparent;
  }
`;
